<template>
  <div class="flex-1-1 p-x-1:mo BACKGROUND  ">
    <div class="PERFORMANCE">
      <h2 class=" d-flex flex-1-1 m-l-1:mo fd-column ai-center:mo m-r-1 m-r-6:w" >
        Performance
      </h2>
    </div>
    <div class="d-flex flex-1-1 fd-column">
      <performance-tabs class="m-b-1"/>
      <div v-if="activePerformanceTabName===$options.PERFORMANCE_TAB_NAMES.summary.key">
        <performance-summary/>
      </div>
      <div v-if="activePerformanceTabName===$options.PERFORMANCE_TAB_NAMES.history.key">
        <performance-history/>
      </div>
      <div v-if="activePerformanceTabName===$options.PERFORMANCE_TAB_NAMES.reviews.key">
        <reviews/>
      </div>
      <div v-if="activePerformanceTabName===$options.PERFORMANCE_TAB_NAMES.points.key">
        <points/>
      </div>
    </div>
  </div>
</template>

<script>
import Points from '@/views/Account/Pro/views/Points';
import { PERFORMANCE_TAB_NAMES } from '@/constants/performance-tab-names';
import Reviews from '@/views/Account/Pro/views/Reviews';
import PerformanceTabs from './components/PerformanceTabs';
import PerformanceSummary from './components/Summary/Summary';
import PerformanceHistory from './components/History/History';

export default {
  PERFORMANCE_TAB_NAMES,
  name: 'dashboard-performance',
  components: {
    PerformanceTabs,
    PerformanceSummary,
    PerformanceHistory,
    Reviews,
    Points,
  },

  computed: {
    activePerformanceTabName () {
      return this.$route.params.activePerformanceTab;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .PERFORMANCE {
    padding: 1*$unit 1*$unit;
    display: flex;
    @include mobile-only() {
      border-bottom: solid 1px $color-gray40;
    }

    h2 {
      margin: 0;
    }
  }
  .BACKGROUND {
    background-color: white;
  }
</style>
